/**
 * Shared constants for the Attendee Mobile UX swipeable navigation system.
 * These constants define the fixed section order, UI thresholds, and
 * image optimization constraints used across frontend components.
 */

export const SECTION_KEYS = [
  'my-weekend',
  'guest-toolkit',
  'events-schedule',
  'marketplace',
  'announcements',
  'chapters',
  'krio-fun-facts',
  'knowledge-base',
  'my-story',
  'settings',
] as const;

export const SECTION_LABELS = [
  'My Weekend',
  'Guest Toolkit',
  'Events & Schedule',
  'Marketplace',
  'Announcements',
  'Chapters',
  'Krio Fun Facts',
  'Knowledge Base',
  'My Story',
  'Settings',
] as const;

/** Total number of navigable sections */
export const TOTAL_SECTIONS = 10;

/** Minimum horizontal swipe distance (px) to trigger navigation */
export const SWIPE_THRESHOLD = 50;

/** Fixed height of the header panel (px) */
export const HEADER_HEIGHT = 200;

/** Viewport width breakpoint for mobile layout (px) */
export const MOBILE_BREAKPOINT = 768;

/** Duration of panel transition animations (ms) */
export const ANIMATION_DURATION = 300;

/** Maximum allowed upload file size before optimization (bytes) — 10MB */
export const MAX_UPLOAD_SIZE = 10 * 1024 * 1024;

/** Maximum target output file size after optimization (bytes) — 200KB */
export const MAX_OUTPUT_SIZE = 200 * 1024;

/** Maximum image width after resize (px) — no upscaling */
export const MAX_WIDTH = 1080;

/** Accepted MIME types for panel image uploads */
export const ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;

/** Timeout for server-side image processing (ms) */
export const PROCESSING_TIMEOUT = 30_000;

/** Type derived from the section key tuple */
export type SectionKey = (typeof SECTION_KEYS)[number];

/** Type derived from the section label tuple */
export type SectionLabel = (typeof SECTION_LABELS)[number];
